import dayjs from 'dayjs';
import numeral from 'numeral';
import { growthbook } from '~/App';
import { ProfileRequestGrowthBookConfig } from '~/types';

export const downloadFile = async (fileOrUrl: File | string): Promise<void> => {
  const a = document.createElement('a');

  let url;

  if (fileOrUrl instanceof File) {
    url = window.URL.createObjectURL(fileOrUrl);
    a.download = fileOrUrl.name;
  } else {
    url = fileOrUrl;
  }

  a.href = url;

  a.click();

  window.URL.revokeObjectURL(url);
  a.remove();
};

export const downloadFiles = async (fileOrUrls: File[] | string[]): Promise<void> => {
  if (fileOrUrls.length === 0) {
    return;
  }

  const Timeout = 1000; // TODO: It may doesn't work depending on the sort of browser. Please set the value larger if it happens.

  fileOrUrls.forEach((url, index) => {
    window.setTimeout(() => downloadFile(url), index * Timeout);
  });
};

export const downloadBlobFile = (data: unknown, filename: string): void => {
  const url = window.URL.createObjectURL(new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export const downloadBlobFileWithContentType = (data: any, filename?: string, contentType?: string): void => {
  let url: string;

  const link = document.createElement('a');

  if (data instanceof File) {
    url = window.URL.createObjectURL(data);
    link.setAttribute('download', data.name);
  } else if (contentType && !contentType.includes('text/csv')) {
    url = window.URL.createObjectURL(new Blob([data], { type: contentType }));
  } else {
    url = window.URL.createObjectURL(new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' }));
  }

  link.href = url;
  if (filename) {
    link.setAttribute('download', filename);
  }

  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const downloadResponseTypeBlobFile = (data: any, filename: string, contentType?: string): void => {
  const url = window.URL.createObjectURL(new Blob([data], { type: contentType }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getFileNameAndExtension = (fullFileName: string): [string, string] => {
  const [_, name = '', ext = ''] = Array.from(/(.*)(\.[a-zA-Z0-9]+$)/.exec(fullFileName) || []);

  return [name, ext];
};

export const stringSort = (a: string, b: string, orderBy: 'asc' | 'desc') => {
  const nameA = a.toUpperCase();
  const nameB = b.toUpperCase();
  if (nameA < nameB) return orderBy === 'asc' ? -1 : 1;
  if (nameA > nameB) return orderBy === 'asc' ? 1 : -1;

  return 0;
};

export const listSliceData = <T>(list: T[], target: T): T[] => {
  const index = list.findIndex((item) => item === target);
  if (index !== -1) {
    list.splice(index, 1);
  }
  return list;
};

export function parseValueToValueArray<T>(value: T | T[]): T[] {
  if (value === undefined || value === null || value === '') {
    return [];
  }
  if (typeof value === 'object' && Array.isArray(value)) {
    return value;
  }
  return [value];
}

export const formatNumber = (num: number): string => numeral(num).format('0,0');
export const formatDate = (date?: string | null) => {
  if (!date) {
    return '';
  }
  return dayjs(date).format('MMM DD, YYYY');
};

export const getEnvironmentKey = (env?: string): keyof ProfileRequestGrowthBookConfig => {
  return env === 'production' ? 'production' : 'development';
};

export * from './@constants';
export * from './array/array';
export * from './customTags';
export * from './listingTabGroup';
export * from './parser';
export * from './parser/domainType';
export * from './parser/filter';
export * from './parser/parseChannelDisplayTypeEnum';
export * from './parser/parseMarqFoundationEnumsCountryCodeEnum';
export * from './parser/parserSnakeCaseToCamelCase';
export * from './permission';
export * from './selectedBrandId';
export * from './string/safeDecodeURIComponent';
export * from './toast';
